let imgPath =
  process.env.REACT_APP_ENV === 'qa' || process.env.REACT_APP_ENV === 'dev'
    ? 'https://d1z72rr1bj4jw1.cloudfront.net'
    : 'https://d21itqh87zixpv.cloudfront.net'
let tossClientKey =
  process.env.REACT_APP_ENV === 'qa' || process.env.REACT_APP_ENV === 'dev'
    ? process.env.REACT_APP_TOSS_TEST_CLIENT_KEY
    : process.env.REACT_APP_TOSS_CLIENT_KEY
let appUrl =
  process.env.REACT_APP_ENV === 'qa'
    ? 'https://qa.motiners.com'
    : process.env.REACT_APP_ENV === 'dev'
    ? 'http://localhost:3000'
    : 'https://motiners.com'
const constants = {
  appUrl: appUrl,
  imagePath: imgPath,
  tossClientKey: tossClientKey,
  appRedirectLink: 'https://plink.motiners.com/tV8u',
  appStoreLink: 'https://apps.apple.com/kr/app/%EB%AA%A8%ED%8B%B0%EB%84%88%EC%8A%A4/id1556370860',
  playStoreLink: 'https://play.google.com/store/apps/details?id=com.motiners.bundle',
}

export const RequireRule = (message) => ({
  rule: /.+/,
  match: true,
  message,
})

export const CantContainWhitespace = (message) => ({
  rule: /\s/,
  match: false,
  message,
})

export const CantStartNumber = (message) => ({
  rule: /^\d/,
  match: false,
  message,
})

export const MinimumLengthLimit = (limit, message) => ({
  rule: new RegExp(`(.){${limit}}`),
  match: true,
  message,
})

export const CanNumberOnly = (message) => ({
  rule: /[^0-9]/g,
  match: false,
  message,
})

export const SHIPPING_ACTION_ARR = [
  '부재시 문앞에 놓아주세요',
  '배송전에 미리 연락주세요',
  '부재시 경비실에 맡겨 주세요',
  '부재시 전화주시거나 문자 남겨 주세요',
]

export const SHIPPING_EXCEPTIONS = [
  { zipcodeStart: '22386', zipcodeEnd: '22388', type: 'other' },
  { zipcodeStart: '23004', zipcodeEnd: '23010', type: 'other' },
  { zipcodeStart: '23100', zipcodeEnd: '23116', type: 'other' },
  { zipcodeStart: '23124', zipcodeEnd: '23136', type: 'other' },
  { zipcodeStart: '31708', zipcodeEnd: '31708', type: 'other' },
  { zipcodeStart: '32133', zipcodeEnd: '32133', type: 'other' },
  { zipcodeStart: '33411', zipcodeEnd: '33411', type: 'other' },
  { zipcodeStart: '40200', zipcodeEnd: '40240', type: 'other' },
  { zipcodeStart: '46768', zipcodeEnd: '46771', type: 'other' },
  { zipcodeStart: '52570', zipcodeEnd: '52571', type: 'other' },
  { zipcodeStart: '53031', zipcodeEnd: '53033', type: 'other' },
  { zipcodeStart: '53089', zipcodeEnd: '53104', type: 'other' },
  { zipcodeStart: '54000', zipcodeEnd: '54000', type: 'other' },
  { zipcodeStart: '56347', zipcodeEnd: '56349', type: 'other' },
  { zipcodeStart: '57068', zipcodeEnd: '57069', type: 'other' },
  { zipcodeStart: '58760', zipcodeEnd: '58762', type: 'other' },
  { zipcodeStart: '58800', zipcodeEnd: '58810', type: 'other' },
  { zipcodeStart: '58816', zipcodeEnd: '58818', type: 'other' },
  { zipcodeStart: '58826', zipcodeEnd: '58826', type: 'other' },
  { zipcodeStart: '58828', zipcodeEnd: '58866', type: 'other' },
  { zipcodeStart: '58953', zipcodeEnd: '58958', type: 'other' },
  { zipcodeStart: '59102', zipcodeEnd: '59103', type: 'other' },
  { zipcodeStart: '59106', zipcodeEnd: '59106', type: 'other' },
  { zipcodeStart: '59127', zipcodeEnd: '59127', type: 'other' },
  { zipcodeStart: '59129', zipcodeEnd: '59129', type: 'other' },
  { zipcodeStart: '59137', zipcodeEnd: '59166', type: 'other' },
  { zipcodeStart: '59421', zipcodeEnd: '59421', type: 'other' },
  { zipcodeStart: '59531', zipcodeEnd: '59531', type: 'other' },
  { zipcodeStart: '59551', zipcodeEnd: '59551', type: 'other' },
  { zipcodeStart: '59563', zipcodeEnd: '59563', type: 'other' },
  { zipcodeStart: '59568', zipcodeEnd: '59568', type: 'other' },
  { zipcodeStart: '59650', zipcodeEnd: '59650', type: 'other' },
  { zipcodeStart: '59766', zipcodeEnd: '59766', type: 'other' },
  { zipcodeStart: '59781', zipcodeEnd: '59790', type: 'other' },
  { zipcodeStart: '63365', zipcodeEnd: '63365', type: 'jeju' },
  { zipcodeStart: '63000', zipcodeEnd: '63001', type: 'jeju' },
  { zipcodeStart: '63000', zipcodeEnd: '63644', type: 'jeju' },
]

export default constants
